import { selectUser } from 'store';

import { useAppSelector } from 'hooks';

import { PartnerNameType } from 'models/user.types';

export const usePartnerPatient = (partnerName: PartnerNameType) => {
  const { companyPartners } = useAppSelector(selectUser);
  const isPartnerPatient = () => {
    const lowerPartnerName = partnerName.toLowerCase();
    return (
      companyPartners?.connectedPartners?.some(
        (p) => p.partnerName.toLowerCase() === lowerPartnerName
      ) ||
      String(companyPartners?.onboardingPartner?.partnerName)
        .toLowerCase()
        .includes(lowerPartnerName)
    );
  };

  return isPartnerPatient();
};
